import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import AuthLayout from "./AuthLayout";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");

    if (!email.trim()) {
      setError("Please enter your email address.");
      return;
    }

    setLoading(true);
    try {
      const response = await api.post("/forgot-password", {
        email: email.trim().toLowerCase(),
      });

      setSuccess(
        response?.data?.message ||
          "If an account exists for this email, a password reset link has been sent."
      );
    } catch (requestError) {
      console.error(requestError);
      setError(requestError?.response?.data?.message || "Unable to send reset link right now.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Let’s get you back in.">
          <div className="mb-7 border-b border-white/10 pb-5 text-center">
            <p className="text-xs font-bold uppercase tracking-[0.28em] text-teal-300">
              The Vergara Rentals
            </p>
            <h1 className="mt-2 text-2xl font-bold text-white">Forgot Password</h1>
            <p className="mt-2 text-sm text-slate-300">
              Enter your email and we will send you a password reset link.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="forgotpassword-email" className="mb-2 block text-sm font-semibold text-slate-200">Email Address</label>
              <input
                type="email"
                required
                id="forgotpassword-email" autoComplete="email" value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="you@example.com"
                className="w-full rounded-lg border border-white/10 bg-white px-4 py-3 text-slate-900 outline-none transition focus:border-teal-400 focus:ring-2 focus:ring-teal-400/30"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-lg bg-teal-600 py-3 text-sm font-semibold text-white transition hover:bg-teal-500 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {loading ? "Sending reset link..." : "Send Reset Link"}
            </button>

            {error ? (
              <div role="alert" className="rounded-lg border border-red-300/30 bg-red-500/15 px-4 py-3 text-sm text-red-100">
                {error}
              </div>
            ) : null}

            {success ? (
              <div role="status" className="rounded-lg border border-emerald-300/30 bg-emerald-500/15 px-4 py-3 text-sm text-emerald-100">
                {success}
              </div>
            ) : null}
          </form>

          <p className="mt-6 text-center text-sm text-slate-400">
            Remembered your password?{" "}
            <Link to="/login" className="font-semibold text-teal-300 hover:text-teal-200">
              Back to Login
            </Link>
          </p>
    </AuthLayout>
  );
}
